import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { APP_INIT } from '../actions/lifeCycleActions';
import { getUserInfo } from '../actions/userActions';
import { getUserApiKeys } from '../actions/apiKeyActions';
import { getAffiliateCount } from '../actions/affiliateActions';
import { getUserReports, getUserReportWriterResults } from '../actions/reportActions';
import { pingBackend } from '../actions/wsConnectionActions';
import { AUTH_SUCCESS, AUTH_NONE, FORCED_LOGOUT, validateSessionToken, subscribeToLogoutEvent, logout } from '../actions/authActions';
import { loadStartupData } from '../actions/appActions';
var authMiddleware = function authMiddleware(store) {
  return function (next) {
    return function (action) {
      var dispatch = store.dispatch;
      if (action.type === AUTH_NONE) {
        onLogout(action);
      } else if (action.type === AUTH_SUCCESS) {
        onLogin(dispatch, action);
      } else if (action.type === APP_INIT) {
        onAppInit(dispatch);
      } else if (action.type === FORCED_LOGOUT) {
        onLogout(action);
      }
      return next(action);
    };
  };
};
var setOnConnectionChange = function setOnConnectionChange(dispatch) {
  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection || navigator.msConnection;
  if (connection) {
    connection.onchange = function () {
      if (navigator.onLine) {
        dispatch(pingBackend());
      }
    };
  }
};
var onAppInit = function onAppInit(dispatch) {
  setOnConnectionChange(dispatch);
  dispatch(subscribeToLogoutEvent());
  var token = localStorage.getItem('token');
  if (token) {
    dispatch(validateSessionToken(token));
  }

  // (!oldValue) If we are creating the token key in localStorage, we want to log in on any tabs
  // (!newValue) If we are removing the token key in localStorage, we want to log out on any tabs
  window.addEventListener('storage', function (event) {
    var key = event.key,
      oldValue = event.oldValue,
      newValue = event.newValue;
    if (key === 'token') {
      if (!newValue || !oldValue) {
        window.location.reload();
      }
    }
  });
};
var onLogin = function onLogin(dispatch, action) {
  localStorage.setItem('token', action.payload.token);
  dispatch(initDataAfterLogin(action.payload.userId));
};
var onLogout = function onLogout(action) {
  localStorage.removeItem('token');
  if (action.type === FORCED_LOGOUT || action.payload.wasAuthenticatedBefore) {
    window.location.reload();
  }
};
export var checkAuth = function checkAuth(dispatch) {
  var token = localStorage.getItem('token');
  if (token) {
    dispatch(validateSessionToken(token));
  } else {
    dispatch(logout());
  }
};
var initDataAfterLogin = function initDataAfterLogin(userId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(loadStartupData());
              dispatch(getUserInfo(userId));
              dispatch(getUserApiKeys(userId));
              dispatch(getAffiliateCount());
              dispatch(getUserReports(userId));
              dispatch(getUserReportWriterResults());
            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default authMiddleware;